import ApiService from "./api.service";

class BulletinService extends ApiService {
    getBulletins() {
        return this.get(`api/management/bulletin`);
    }

    getLatestBulletinItem() {
        return this.get(`api/management/bulletin/latest`);
    }

    updateClickStats(id) {
        return this.post(`api/management/bulletin/${id}/update-click-stats`);
    }
}

export default new BulletinService();
